//import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
//import i18next from "../../i18n/i18n.config";

import { default as Slider } from "antd/lib/slider";
import Accordion from "react-bootstrap/Accordion";

// As per Albert-Jason call, we removed these 2 from here
//import "bootstrap_css"; // Moved to index.
//import "bootstrap_js"; NOT REQUIRED! Not even for development. Removing this, fixed the dropdown menu issue with conflicting bootstrap versions (Nikita customized a few things)


import CheckBox from "../Checkbox/Checkbox";

export const Filter = (props: any) => {
    const { t, i18n } = useTranslation();
    const resource_bundle = i18n.getResourceBundle(window.Languages.language, '');
    const names = {
        "brands": "checkbox",
        "types": "checkbox",
        "axes": "checkbox",
        "tags": "checkbox",
        "applications": "checkbox",
        "plugins": "checkbox",
        "mechanism-type": "checkbox",
        "sizes": "checkbox",
        "publishers": "checkbox",
        "categories": "checkbox",
        "controllers": "checkbox",
        "extensions": "checkbox",
        "price": "checkbox",

        "reach": "slider",
        "payload": "slider",
        "weight": "slider",
        "repeatability": "slider",
        "mechanism-count": "slider",
        "tool-count": "slider",
        "object-count": "slider"
    };

    let translated_props: any = "";
    switch (props.type) {
        case "types":
        case "mechanism-type":
            translated_props = resource_bundle['item-types'];
            break;

        case "tags":
            translated_props = resource_bundle['tags-station'];
            break;

        case "applications":
            translated_props = resource_bundle['application'];
            break;

        case "sizes":
            translated_props = {
                "Small": resource_bundle["filters-stations"]["size-small"],
                "Medium": resource_bundle["filters-stations"]["size-med"],
                "Large": resource_bundle["filters-stations"]["size-large"]
            }
            break;

        case "categories":
            translated_props = resource_bundle['addin-types'];
            break;
    }

    return (
        <>
            {names[props.type] == "checkbox" && (
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey={"filter-" + props.type}>
                        <Accordion.Header className={ (props.first) ? "first-acc-header" : "filter-title" }>
                            <h6>{t(props.title)}</h6>
                        </Accordion.Header>
                        <Accordion.Body className="acc-scroll">
                            {Object.keys(props.data).map((key) => (
                                <div key={"wrapper-" + key}>
                                    <div
                                        key={"filter-" + key}
                                        className="filter float-left"
                                    >
                                        <CheckBox
                                            name={key}
                                            key={key}
                                            value={key}

                                            label={
                                                translated_props != ""
                                                ? translated_props[key]
                                                : key
                                            }
                                            checked={props.data[key]}
                                            onChange={props.handler}
                                        />
                                    </div>
                                    {props.counts[props.type].hasOwnProperty(key) && (
                                        <div
                                            key={"count-" + key}
                                            className="float-right qty-display"
                                        >
                                            {props.counts[props.type][key]}
                                        </div>
                                    )}
                                    <div
                                        key={key}
                                        className="float-clear"
                                    ></div>
                                </div>
                            ))}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}

            {names[props.type] == "slider" && (
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey={"filter-" + props.type}>
                        <Accordion.Header className={ (props.first) ? "first-acc-header" : "filter-title" }>
                            <h6>{t(props.title)}</h6>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <p className="float-left">
                                    {props.data[0].toFixed(props.decimal) + " " + props.unit}
                                </p>
                                <p className="float-right">
                                    {props.data[1].toFixed(props.decimal) + " " + props.unit}
                                </p>
                                <Slider
                                    id="reach-slider"
                                    className="float-clear"
                                    range
                                    onChange={props.handler}
                                    min={props.data_default[0]}
                                    max={props.data_default[1]}
                                    defaultValue={[props.data_default[0], props.data_default[1]]}
                                    tooltip={{ open: false }}
                                    step={props.step}
                                    value={[props.data[0], props.data[1]]}
                                />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}
        </>
    );
}
